export default __webpack_public_path__ + "static/media/10.7999d1bc.jpg";